import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';
import { LoginService } from '../services/login.service';
@Component({
  selector: 'logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private router: Router,
    private loginService: LoginService) { }

  ngOnInit() {
    this.sisenseLogout(sessionStorage.getItem('jwtToken'));
    sessionStorage.removeItem('loginClickStatus');
    sessionStorage.removeItem('currentUserEmail');
    sessionStorage.removeItem('Authorization');
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }

  sisenseLogout(jwtToken) {
    const headerData = {
      Authorization: 'Bearer ' + jwtToken,
    };

    const reqHeader = new HttpHeaders(headerData);
    this.loginService.logoutSisenseUser(reqHeader);
  }
}
